import VoucherBlank from './VoucherBlank'

export default VoucherBlank
